import { api, apiUrl } from "../../../shared/services/service";
import type { VesselDataDashboard, VesselDataListResponse } from "../models/vessel-data.models";
import axios from "axios";

const VESSEL_DATA_ENDPOINT = `${apiUrl}/pbi/vessel-data`;

export const getVesselDataVessels = async (
  query: string,
  signal?: AbortSignal,
): Promise<VesselDataListResponse> => {
  const response = await api.get<VesselDataListResponse>(VESSEL_DATA_ENDPOINT, {
    params: { q: query || undefined, limit: 100 },
    signal,
  });

  return response.data;
};

export const getVesselDataDashboard = async (
  imoNumber: string,
  signal?: AbortSignal,
): Promise<VesselDataDashboard> => {
  const response = await api.get<VesselDataDashboard>(`${VESSEL_DATA_ENDPOINT}/${encodeURIComponent(imoNumber)}`, {
    signal,
  });

  return response.data;
};

export const getVesselDataErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    const response = error.response?.data as { error?: string; message?: string } | undefined;

    return response?.error ?? response?.message ?? error.message;
  }

  return error instanceof Error ? error.message : "Vessel Data could not be loaded.";
};
